module.exports = __webpack_public_path__ + "img/logo.ff659485.png";